import { render, staticRenderFns } from "./DisclaimerPage.vue?vue&type=template&id=12b75736&scoped=true"
import script from "./DisclaimerPage.vue?vue&type=script&lang=js"
export * from "./DisclaimerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b75736",
  null
  
)

export default component.exports